const config = {
    // apiUrl: "https://api-nagpal.chabhiwala.com",
      // apiUrl: "http://localhost:5506",
    apiUrl: "http://13.233.212.61:5506",
}

export default config;